/* tslint:disable */
/* eslint-disable */
/**
 * Indices API
 * Référentiel des indices de branche et de leurs valeurs datées
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RolePrimeDerivee } from './RolePrimeDerivee';
import {
    RolePrimeDeriveeFromJSON,
    RolePrimeDeriveeFromJSONTyped,
    RolePrimeDeriveeToJSON,
    RolePrimeDeriveeToJSONTyped,
} from './RolePrimeDerivee';

/**
 * Garantie d'une branche qui porte un rôle de prime dérivée (Cat Nat, Cat Tech ou Attentat).
 * @export
 * @interface GarantieDeriveeBrancheDto
 */
export interface GarantieDeriveeBrancheDto {
    /**
     * 
     * @type {RolePrimeDerivee}
     * @memberof GarantieDeriveeBrancheDto
     */
    role: RolePrimeDerivee;
    /**
     * 
     * @type {string}
     * @memberof GarantieDeriveeBrancheDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GarantieDeriveeBrancheDto
     */
    shortLabel?: string | null;
}



/**
 * Check if a given object implements the GarantieDeriveeBrancheDto interface.
 */
export function instanceOfGarantieDeriveeBrancheDto(value: object): value is GarantieDeriveeBrancheDto {
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function GarantieDeriveeBrancheDtoFromJSON(json: any): GarantieDeriveeBrancheDto {
    return GarantieDeriveeBrancheDtoFromJSONTyped(json, false);
}

export function GarantieDeriveeBrancheDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GarantieDeriveeBrancheDto {
    if (json == null) {
        return json;
    }
    return {
        
        'role': RolePrimeDeriveeFromJSON(json['role']),
        'code': json['code'] == null ? undefined : json['code'],
        'shortLabel': json['shortLabel'] == null ? undefined : json['shortLabel'],
    };
}

export function GarantieDeriveeBrancheDtoToJSON(json: any): GarantieDeriveeBrancheDto {
    return GarantieDeriveeBrancheDtoToJSONTyped(json, false);
}

export function GarantieDeriveeBrancheDtoToJSONTyped(value?: GarantieDeriveeBrancheDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'role': RolePrimeDeriveeToJSON(value['role']),
        'code': value['code'],
        'shortLabel': value['shortLabel'],
    };
}

